import moment from 'moment-timezone';
import Vue from 'vue';

let fn = (date = null) => {
  if (date) {
    return moment(
      date,
      [
        'MM-DD-YYYY',
        'DD-MM-YYYY',
        'YYYY-MM-DD',
        'YYYY-DD-MM',
        'YYYY-DD-MM HH;MM;SS',
      ],
      false
    );
  }
  return moment();
};
Vue.$moment = Vue.prototype.$moment = moment;
window.$moment = moment;
